var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.59631 11.3333C8.25764 11.3333 8.85415 10.9369 9.26277 10.3733C9.8997 9.49299 10.6992 8.76638 11.6103 8.24C12.2035 7.89867 12.7179 7.39022 12.9666 6.71556C13.1412 6.24289 13.2308 5.73845 13.2308 5.22933V4.66667C13.2308 4.48986 13.2956 4.32029 13.411 4.19526C13.5264 4.07024 13.6829 4 13.8461 4C14.3358 4 14.8054 4.21071 15.1516 4.58579C15.4978 4.96086 15.6923 5.46957 15.6923 6C15.6923 7.024 15.479 7.99378 15.0991 8.86044C14.8808 9.35644 15.1869 10 15.6939 10M15.6939 10H18.2589C19.1007 10 19.8548 10.6169 19.9442 11.5244C19.9811 11.8996 20 12.28 20 12.6667C20.0034 15.099 19.2361 17.4589 17.8265 19.352C17.5081 19.7804 17.0166 20 16.5095 20H13.2144C12.818 20 12.4234 19.9307 12.0468 19.7956L9.49169 18.8711C9.11516 18.7355 8.72091 18.6664 8.3241 18.6667H6.99815M15.6939 10H13.8461M6.99815 18.6667C7.06626 18.8489 7.1401 19.0267 7.21969 19.2018C7.38133 19.5573 7.15569 20 6.79056 20H6.04554C5.3161 20 4.64 19.5396 4.42749 18.784C4.1433 17.7736 3.99923 16.723 4 15.6667C4 14.2862 4.24205 12.968 4.68185 11.7573C4.93293 11.0693 5.57292 10.6667 6.25641 10.6667H7.12041C7.50769 10.6667 7.73169 11.1609 7.53067 11.52C6.82986 12.7697 6.46025 14.2044 6.46236 15.6667C6.46236 16.728 6.65272 17.7404 6.99898 18.6667H6.99815Z",
    stroke: "#5C6075",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.06aa9ac75def076d3b46b7e94819bbf9.svg";
export { ForwardRef as ReactComponent };